export enum DocumentType {
  Elettorale = 'CE',
  Anpr = 'CA',
  Ansc = 'SC',
  Attestazione = 'AT',
  Operazione = 'CO',
  Autentica = 'AU',
  Dichiarazione = 'DS',
}
